import AttendanceSerializer from './base';

export default class NzMoeDay extends AttendanceSerializer {}
